import React, { Component } from "react";
import { Modal, Row, Col } from "react-bootstrap";
import parseHtml from "html-react-parser";
import "./questionsModal.scss";

class QuestionsModal extends Component {
  // Parse HTML
  parseFun(html) {
    if (!html && html !== 0) return "";
    return <div className="qm-html">{parseHtml(String(html))}</div>;
  }

  // Question Number
  idFunction(index) {
    return `Q${index + 1}`;
  }

  // Match-the-following questions store both lists as JSON in `question`.
  parseLists(question) {
    try {
      const qText = question.question
        .replaceAll('src="', "src='")
        .replaceAll('" alt=""', "' alt=''")
        .replaceAll('" ', "' ")
        .replaceAll('="', "='")
        .replace(/<\/p>\s*<p>/g, "</p><p>");
      return JSON.parse(qText);
    } catch {
      return null;
    }
  }

  listType(type) {
    return type === "alphabets" ? "A" : type === "numbers" ? "1" : "I";
  }

  renderList(items, field, type) {
    return (
      <ol type={this.listType(type)}>
        {items.map((item, idx) => (
          <li key={idx}>{this.parseFun(item[field])}</li>
        ))}
      </ol>
    );
  }

  // OPTIONS (no checkbox)
  renderOptions(question) {
    const opts = [
      { key: "A", text: question.option1 },
      { key: "B", text: question.option2 },
      { key: "C", text: question.option3 },
      { key: "D", text: question.option4 }
    ].filter((opt) => opt.text || opt.text === 0);

    if (!opts.length) return null;

    return (
      <div className="qm-options">
        {opts.map((opt) => (
          <div key={opt.key} className="qm-option">
            <span className="qm-option-key">{opt.key}</span>
            <div className="qm-text">{this.parseFun(opt.text)}</div>
          </div>
        ))}
      </div>
    );
  }

  renderBody(question) {
    const qType = String(question.qtype);

    // MATCH TYPE
    if (["3", "9"].includes(qType)) {
      const lists = this.parseLists(question);
      return (
        <>
          <strong>Match the following</strong>
          {lists && (
            <Row className="qm-lists">
              <Col sm={6}>
                <h6>List I</h6>
                {this.renderList(lists, "qlist1", question.list1type)}
              </Col>
              <Col sm={6}>
                <h6>List II</h6>
                {this.renderList(lists, "qlist2", question.list2type)}
              </Col>
            </Row>
          )}
        </>
      );
    }

    return this.parseFun(question.question);
  }

  // Render question card
  renderQuestionCard(question, index) {
    const qType = String(question.qtype);

    return (
      <div key={index} className="qm-card">
        {qType === "5" && question.compquestion && (
          <div className="qm-passage">{this.parseFun(question.compquestion)}</div>
        )}

        <div className="qm-question">
          <span className="qm-number">{this.idFunction(index)}</span>
          <div className="qm-text">
            {this.renderBody(question)}
            {qType === "8" && <span className="qm-tag">Numerical answer</span>}
          </div>
        </div>

        {qType !== "8" && this.renderOptions(question)}
      </div>
    );
  }

  // Consecutive questions of the same subject share one heading; numbering
  // stays the exam's own order.
  groupBySubject(questions) {
    const groups = [];
    questions.forEach((question, index) => {
      const subject = question.subject_name || "";
      const last = groups[groups.length - 1];
      if (last && last.subject === subject) last.items.push({ question, index });
      else groups.push({ subject, items: [{ question, index }] });
    });
    return groups;
  }

  // MAIN RENDER
  render() {
    const { show, onHide } = this.props;
    const questions = Array.isArray(this.props.getPracticeQuestions) ? this.props.getPracticeQuestions : [];

    return (
      <Modal centered size="lg" show={show} onHide={onHide} className="questions-modal">
        <div className="qm-header">
          <h5>
            Questions
            {questions.length > 0 && <span className="qm-count">{questions.length}</span>}
          </h5>
          <button type="button" className="qm-close" aria-label="Close" onClick={onHide}>
            ×
          </button>
        </div>

        <Modal.Body className="qm-body">
          {questions.length === 0 ? (
            <div className="qm-empty">No questions found.</div>
          ) : (
            this.groupBySubject(questions).map((group, g) => (
              <React.Fragment key={g}>
                {group.subject && <div className="qm-subject">{group.subject}</div>}
                {group.items.map(({ question, index }) => this.renderQuestionCard(question, index))}
              </React.Fragment>
            ))
          )}
        </Modal.Body>
      </Modal>
    );
  }
}

export default QuestionsModal;
